import type { GeoJSONSource } from 'mapbox-gl';
import type { NormalisedSelectedVessels } from '../../../dossiers-and-panels/vessel-dossier/vessel-dossier.slice';
import type { AlertingVessels } from '../../../maritime-menu-options/alert-panel/alertingVessels.model';
import type { Vessel } from '../../../models/vessels/vessel.model';
import GeoHelper from '../../../utils/geo-helpers.utils';
import MapHelpers from '../../map.utils';
import type MapLayer from '../map-layer.enum';

export function updateVesselFeatures(
  layerId: MapLayer | string,
  vesselFeatures: AlertingVessels[],
  selectedVessels: NormalisedSelectedVessels
) {
  const features: AlertingVessels[] = vesselFeatures.filter((featureElement) =>
    selectedVessels.allIds.find(
      (id) =>
        selectedVessels.byId[id].additionalDetails?.before_message
          ?.timestamp ===
        featureElement.additionalDetails?.before_message?.timestamp
    )
  );

  const geoJsonFeatures = GeoHelper.vesselsToGeoJSONFeatures(features);
  const geojson = GeoHelper.createGeoJSON(geoJsonFeatures);
  const source = MapHelpers.getSource(layerId) as GeoJSONSource;
  source?.setData(geojson);
}

export function setVesselFeatures(
  layerId: MapLayer | string,
  vesselFeatures: Vessel[]
) {
  const geoJsonFeatures = GeoHelper.vesselsToGeoJSONFeatures(vesselFeatures);
  const geojson = GeoHelper.createGeoJSON(geoJsonFeatures);
  const source = MapHelpers.getSource(layerId) as GeoJSONSource;
  source?.setData(geojson);
}
